<!-- 侧边工具栏 -->
<template>
    <div class="sidebar_wrapper">
        <div class="sidebar_item tel" 
            @mouseover="bind_toggle_show('tel', true)"
            @mouseout="bind_toggle_show('tel', false)">
            <div class="show_tel" v-show="show_tel">
                <p class="number">18825182825</p>
                <p class="desc">全国服务热线</p>
            </div>
        </div>
        <div class="sidebar_item wechat" 
            @mouseover="bind_toggle_show('wechat', true)"
            @mouseout="bind_toggle_show('wechat', false)">
            <div class="show_wechat" v-show="show_wechat">
                <img src="https://oimagec1.ydstatic.com/image?id=-1144634288768858846&product=xue">
            </div>
        </div>
        <div class="sidebar_item top" @click="bind_top"></div>
    </div>
</template>
<script>
    export default {
        data() {
            return {
                show_tel: false,
                show_wechat: false
            };
        },
        methods: {
            bind_toggle_show(tag, flag) {
                this[`show_${tag}`] = flag;
            },
            bind_top() {
                let gotopTimer = setInterval(function() {
                    let restHeight = document.documentElement.scrollTop || document.body.scrollTop;
                        if (restHeight <= 0) {
                            clearInterval(gotopTimer);
                        } else {
                            window.scrollTo(0, restHeight-100);
                        }   
                }, 16.7)
            }
        }
    }
</script>
<style>
    .sidebar_wrapper {
        z-index: 1001;
        position: fixed;
        bottom: 50px;
        right: 20px;
        border-radius: 5px;
        background: #18273d;
        /* overflow: hidden; */
    }
    /* 每个边栏样式 */
    .sidebar_item {
        position: relative;
        width: 48px;        
        height: 48px;
        line-height: 48px;
        text-align: center;
        opacity: 0.9;
        cursor: pointer;
        border-radius: 5px;
    }
    /* 边栏-电话 */
    .sidebar_item.tel {
        background-image: url(//shared.ydstatic.com/ead/OfficialWebsite/img/ic_telephone_normal.png)
    }
    .sidebar_item.tel:hover {
        background-image: url(//shared.ydstatic.com/ead/OfficialWebsite/img/ic_telephone_hover.png)
    }
    /* 电话hover之后的展示 */
    .show_tel{
        position: absolute;
        right: 63px;
        top: 50%;
        margin-top: -30px;
        width: 142px;
        height: 61px;
        background: #2f3c50;
        border-radius: 4px;
        text-align: center;
    }

    .show_tel .number {
        margin-top: 14px;
        font-size: 14px;
        color: #fff;
        line-height: 14px;
    }
    
    .show_tel .desc {
        margin-top: 6px;
        font-size: 12px;
        color: #fff;
        line-height: 12px;
        opacity: 0.5;
    }
    /* 微信hover之后的展示 */
    .show_wechat{
        position: absolute;
        right: 63px;
        top: 50%;
        margin-top: -54px;
        width: 115px;
        height: 115px;
        padding: 5px;
        background: #2f3c50;
        border-radius: 4px;
    }
    /* 小三角 */
    .show_wechat:after, .show_tel:after {
        content: '';
        position: absolute;
        right: -5px;
        top: 50%;
        margin-top: -5px;
        width: 10px;
        height: 10px;
        transform: rotate(45deg);
        -ms-transform: rotate(45deg);
        background: #2f3c50;
        border-radius: 2px;
    }
    /* 边栏-微信 */
    .sidebar_item.wechat {
        background-image: url(//shared.ydstatic.com/ead/OfficialWebsite/img/ic_wechat_normal.png)
    }
    .sidebar_item.wechat:hover {
        background-image: url(//shared.ydstatic.com/ead/OfficialWebsite/img/ic_wechat_hover.png)
    }
    /* 边栏-回到顶部 */
    .sidebar_item.top {
        background-image: url(//shared.ydstatic.com/ead/OfficialWebsite/img/ic_gotop_normal.png)
    }
    .sidebar_item.top:hover {
        background-image: url(//shared.ydstatic.com/ead/OfficialWebsite/img/ic_gotop_hover.png)
    }
    /* 模拟分隔符 */
    .sidebar_item:after {
        position: absolute;
        content: '';
        width: 28px;
        height: 1px;
        bottom: 0;
        left: 50%;
        margin-left: -14px;
        background: rgba(255, 255, 255, 0.1);
    }

    .sidebar_item:last-child:after {
        display: none;
    }
</style>




// WEBPACK FOOTER //
// src/components/SideBar.vue